import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import { Info, Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import Tooltip from "@mui/material/Tooltip";
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function ProductsTableData(users, handleEditClick, fetchUsers) {
  const [isActive, setIsActive] = useState(true);

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المنتج "${user.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const token = localStorage.getItem("user-token");
        try {
          const response = await axios.get(
            `${BASE_URL}/manager/products/delete/${user.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المنتج بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/manager/products/active/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة المنتج بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name, image }) => {
    // إذا كان الاسم طويل جداً، قصه وأضف ...
    const maxLength = 20;
    const displayName = name && name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar
          variant="square"
          src={image}
          name={name}
          size="sm"
          sx={{
            backgroundColor: !image ? "grey.300" : "transparent",
            width: 40,
            height: 40,
            "& .MuiSvgIcon-root": {
              fontSize: "1rem",
            },
          }}
        >
          {!image && <PersonIcon fontSize="small" />}
        </MDAvatar>
        <MDBox ml={2} lineHeight={1}>
          <Tooltip title={name} placement="top" arrow>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              sx={{
                maxWidth: 150,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {displayName}
            </MDTypography>
          </Tooltip>
        </MDBox>
      </MDBox>
    );
  };

  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "نشط" : "غير نشط"}
        color={isActive ? "success" : "error"}
        variant="gradient"
        sx="larg"
      />
    </MDBox>
  );
  const Informatine = ({ salesCount, reviewCount, price, stock }) => (
    <MDBox lineHeight={2} display="flex" flexDirection="column">
      <MDTypography variant="caption" color="text" fontWeight="medium">
        عدد المبيعات: {salesCount}
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="medium">
        السعر الاصلي: {price}
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="medium">
        المخزون: {stock}
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="medium">
        التقيمات والمراجعات: {reviewCount}
      </MDTypography>
    </MDBox>
  );
  const Category = ({ category, brand }) => (
    <MDBox lineHeight={2} display="flex" flexDirection="column">
      <MDTypography variant="caption" color="text" fontWeight="medium">
        الفئة: {category || "--"}
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="medium">
        الماركة: {brand || "--"}
      </MDTypography>
    </MDBox>
  );
  return {
    columns: [
      { Header: "الاسم", accessor: "name", width: "30%", align: "left" },
      { Header: "اضيف بواسطة", accessor: "store", align: "center" },
      { Header: "معلومات", accessor: "information", align: "left" },
      { Header: "التصنيف", accessor: "category", align: "left" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: users.map((user) => ({
      name: (
        <Author name={user.name} image={user.medias.length > 0 ? user.medias[0].file_name : null} />
      ),
      store: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.store_id || "--"}
        </MDTypography>
      ),
      information: (
        <Informatine salesCount="0" reviewCount="0" price={user.price} stock={user.quantity} />
      ),
      category: <Category category={user.category?.name} brand={user.brand?.name} />,
      status: <Status isActive={user.is_active} />,
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <CustomSwitch
            checked={user.is_active}
            onChange={(e) => handleActivation(user, e.target.checked)}
            color="default"
          />
          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(user)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(user)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
